<template>
  <div>
    <v-app v-if="renderizacaoLiberada">
      <dashboard-core-drawer :expand-on-hover.sync="expandOnHover" :drawer-expanded.sync="drawerExpanded" />
      <dashboard-core-app-bar v-model="expandOnHover" style="position: absolute" @input="changeExpandDrawer" />
      <dashboard-core-view class="mt-n6" />
    </v-app>
    <loading-overlay :show="isLoading() || !renderizacaoLiberada" />
  </div>
</template>

<script>
  import drawerMixins from '@/mixins/drawerMixins';
  import pusherMixins from '@/mixins/pusherMixins';

  export default {
    components: {
      DashboardCoreAppBar: () => import('@/components/core/AppBar'),
      DashboardCoreDrawer: () => import('@/components/core/Drawer'),
      DashboardCoreView: () => import('@/components/core/View'),
      LoadingOverlay: () => import('@/components/general/LoadingOverlay')
    },

    mixins: [drawerMixins, pusherMixins],

    data: () => ({
      expandOnHover: true,
      drawerExpanded: false,
      renderizacaoLiberada: false
    }),

    created() {
      if (!this.checkIndexCanBeRendered()) {
        this.$router.replace({ name: 'Login' });
        setTimeout(() => location.reload(), 300);
      }
    },

    async mounted() {
      if (!this.checkIndexCanBeRendered()) return;

      await this.$store.dispatch('setUserIsAdmin');
      this.renderizacaoLiberada = true;
      this.openPusherWebNotificChannel();
      this.$Tawk.$startChat();
      const user = this.$store.getters.getUser;
      const tawkUser = {
        name: `${user.nome}  ${user.sobrenome}`,
        email: user.email,
        hash: ''
      };
      this.$Tawk.$updateChatUser(tawkUser);
    },

    methods: {
      changeExpandDrawer() {
        this.drawerExpanded = !this.drawerExpanded;
        this.changeSizeHeaderDashBoard();
      },

      checkIndexCanBeRendered() {
        const user = this.$store.getters.getUser;
        return !(!user.uid || !user.email || !this.$store.getters.getEmpresa || !this.$store.getters.getSiglaEmpresa);
      },

      isLoading() {
        return this.$store.getters.getLoading;
      }
    }
  };
</script>